import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, superAdminOnly = false }) {
  const { user, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="font-mono text-sm text-slate-500" data-testid="auth-loading">
          INITIALIZING SESSION...
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (superAdminOnly && user.role !== "super_admin") return <Navigate to="/" replace />;
  if (adminOnly && user.role !== "admin" && user.role !== "super_admin") return <Navigate to="/" replace />;
  return children;
}
